// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"SocialMedia_socialMedia__w9Bjx","socialMedia__list":"SocialMedia_socialMedia__list__XPBYJ"};